/* Ürün galerisi, yalnızca telefon — assets/hs-gallery.css ile çalışır.
   Fotoğraf eskisi gibi tam genişlikte kalır. Küçük resimler fotoğrafın altında, kaymayan tek bir
   sıra olarak durur: hepsi ekrana sığar (7'den fazlaysa son kutu "+3"), bu yüzden sayfa dikey kaydırılırken
   parmağı yakalamaz (eski şerit yana kayan bir alan olduğu için takılıyordu). Seçili kutunun çerçevesi fotoğraf
   kaydırıldıkça onunla birlikte akar; sıranın üzerinde parmak yana sürüklenince fotoğraflar taranır.
   Fotoğrafa dokununca tam ekran görüntüleyici açılır: yana kaydırma, iki parmak ve çift dokunuşla yakınlaştırma,
   aşağı çekerek ya da geri tuşuyla kapatma. Desen geçişinde ve StarApps galeriyi yeniden çizdiğinde yeniden bağlanır. */
(() => {
  if (window.__hsGallery) return;
  window.__hsGallery = true;

  const mq = matchMedia('(max-width: 749px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EASE = 'cubic-bezier(.2,.8,.2,1)';
  const MAX = 7;
  const bound = new WeakSet();

  const slidesOf = ul => [...ul.children].filter(li => li.tagName === 'LI' && li.offsetWidth > 0);
  const isImage = li => !!li.querySelector('img') && !li.querySelector('video, model-viewer, iframe, deferred-media');
  const sized = (img, w) => {
    const u = new URL(img.currentSrc || img.src, location.href);
    u.searchParams.set('width', String(w));
    return u.toString();
  };
  const bigSrc = img => sized(img, 2048);
  /* object-fit: contain ile görünen resmin kutusu */
  const natW = img => img.naturalWidth || +img.getAttribute('width') || 0;
  const natH = img => img.naturalHeight || +img.getAttribute('height') || 0;
  const shown = img => {
    const r = img.getBoundingClientRect();
    const nw = natW(img) || r.width;
    const nh = natH(img) || r.height;
    const k = Math.min(r.width / nw, r.height / nh) || 1;
    const w = nw * k, h = nh * k;
    return { x: r.left + (r.width - w) / 2, y: r.top + (r.height - h) / 2, w, h };
  };

  /* ---------- küçük resim sırası (galeri ve tam ekran ortak) ----------
     imgs: kaynak <img> listesi · pick(i, smooth): fotoğrafı değiştirir · set(f): çerçeveyi kesirli konuma taşır */
  function makeRail(imgs, pick, extra) {
    const el = document.createElement('div');
    el.className = 'hs-gal-rail' + (extra ? ' ' + extra : '');
    const n = imgs.length;
    const tiles = n > MAX ? MAX - 1 : n;
    const more = n - tiles;
    let html = '';
    for (let i = 0; i < tiles; i++) {
      html += '<button type="button" class="hs-gal-thumb" data-i="' + i + '" aria-label="Fotoğraf ' + (i + 1) + ' / ' + n + '"><img src="' + sized(imgs[i], 160) + '" alt="" decoding="async" draggable="false"></button>';
    }
    if (more) {
      html += '<button type="button" class="hs-gal-thumb hs-gal-thumb--more" data-i="' + tiles + '" aria-label="Diğer ' + more + ' fotoğraf"><img src="' + sized(imgs[tiles], 160) + '" alt="" decoding="async" draggable="false"><span>+' + more + '</span></button>';
    }
    el.innerHTML = html + '<span class="hs-gal-ring" aria-hidden="true"></span>';
    el.hidden = n < 2;
    const btns = [...el.querySelectorAll('.hs-gal-thumb')];
    const ring = el.querySelector('.hs-gal-ring');
    const last = btns.length - 1;
    let on = -1;

    /* kutu boyu: sıra ekrana sığacak kadar, 40–48px */
    const fit = () => {
      const w = el.clientWidth - 32;
      if (w <= 0) return;
      const k = btns.length;
      const t = Math.max(40, Math.min(48, Math.floor((w - 8 * (k - 1)) / k)));
      el.style.setProperty('--t', t + 'px');
    };
    const set = f => {
      const c = Math.max(0, Math.min(last, f));
      const i0 = Math.floor(c), i1 = Math.min(last, i0 + 1), k = c - i0;
      const x = btns[i0].offsetLeft + (btns[i1].offsetLeft - btns[i0].offsetLeft) * k;
      ring.style.transform = 'translateX(' + x + 'px)';
      const a = Math.min(last, Math.round(Math.max(0, f)));
      if (a === on) return;
      on = a;
      btns.forEach((b, j) => {
        b.classList.toggle('is-on', j === a);
        if (j === a) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    };

    /* dokunuş seçer; yana sürükleme fotoğrafları tarar; dikey hareket sayfaya kalır (touch-action: pan-y) */
    let start = null, scrub = false, quiet = 0;
    const under = x => {
      let best = 0, d = Infinity;
      btns.forEach((b, j) => {
        const r = b.getBoundingClientRect();
        const dd = Math.abs(r.left + r.width / 2 - x);
        if (dd < d) { d = dd; best = j; }
      });
      return best;
    };
    el.addEventListener('pointerdown', e => { start = { x: e.clientX, y: e.clientY }; scrub = false; });
    el.addEventListener('pointermove', e => {
      if (!start) return;
      const dx = e.clientX - start.x, dy = e.clientY - start.y;
      if (!scrub && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) scrub = true;
      if (scrub) {
        const j = under(e.clientX);
        if (j !== on) pick(+btns[j].dataset.i, false);
      }
    });
    const end = () => { if (scrub) quiet = performance.now(); start = null; scrub = false; };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('click', e => {
      const b = e.target.closest('.hs-gal-thumb');
      if (!b || performance.now() - quiet < 350) return;
      pick(+b.dataset.i, true);
    });

    return { el, set, fit };
  }

  /* ---------- galeri ---------- */
  function bindGallery(ul) {
    if (bound.has(ul)) return;
    bound.add(ul);
    ul.setAttribute('data-hs-gal', '');
    const host = ul.closest('slider-component') || ul.parentElement;
    let rail = null, sig = '';

    const frac = () => {
      const s = slidesOf(ul);
      if (!s.length) return 0;
      const w = s[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(ul).columnGap) || 0);
      return w ? ul.scrollLeft / w : 0;
    };
    /* liste temada scroll-behavior: smooth; hedef mutlak konumla ve tarama sırasında beklemeden verilir,
       yoksa art arda gelen kaydırmalar birbirini keser ve son fotoğrafa varılamaz */
    const go = (i, smooth) => {
      const s = slidesOf(ul);
      if (!s[i]) return;
      ul.scrollTo({ left: s[i].offsetLeft - s[0].offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'instant' });
    };
    const build = () => {
      const imgs = slidesOf(ul).map(li => li.querySelector('img')).filter(Boolean);
      const next = imgs.map(i => (i.currentSrc || i.src).split('?')[0]).join('|');
      if (next === sig && rail && rail.el.isConnected) return;
      sig = next;
      /* galeri uygulaması (StarApps) listeyi kopyalarken eski sırayı da kopyalar; kopya kaldırılır */
      host.querySelectorAll(':scope > .hs-gal-rail').forEach(el => el.remove());
      rail = makeRail(imgs, go, 'hs-gal-rail--main');
      host.appendChild(rail.el);
      rail.fit();
      rail.set(frac());
    };
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; if (rail) rail.set(frac()); });
    };
    ul.addEventListener('scroll', schedule, { passive: true });
    let rq = false;
    new MutationObserver(() => {
      if (rq) return;
      rq = true;
      requestAnimationFrame(() => { rq = false; build(); });
    }).observe(ul, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'src', 'srcset'] });
    addEventListener('resize', () => { if (rail) { rail.fit(); rail.set(frac()); } }, { passive: true });
    build();
  }

  const scan = () => {
    if (!mq.matches) return;
    document.querySelectorAll('media-gallery ul.product__media-list').forEach(ul => {
      if (ul.offsetHeight > 0) bindGallery(ul);
    });
  };

  /* ---------- tam ekran görüntüleyici ---------- */
  let lb = null;

  function viewer() {
    if (lb) return lb;
    const el = document.createElement('div');
    el.className = 'hs-lb';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Ürün fotoğrafları');
    el.innerHTML =
      '<div class="hs-lb__bg"></div>' +
      '<ul class="hs-lb__track"></ul>' +
      '<div class="hs-lb__top"><span class="hs-gal-count" aria-live="polite"></span>' +
      '<button type="button" class="hs-lb__close" aria-label="Kapat"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="hs-lb__foot"></div>' +
      '<div class="hs-lb__hint">İki parmakla ya da çift dokunarak yakınlaştırın</div>';
    document.body.appendChild(el);

    const st = {
      el,
      bg: el.querySelector('.hs-lb__bg'),
      track: el.querySelector('.hs-lb__track'),
      count: el.querySelector('.hs-lb__count, .hs-gal-count'),
      foot: el.querySelector('.hs-lb__foot'),
      rail: null,
      chrome: [el.querySelector('.hs-lb__top'), el.querySelector('.hs-lb__foot')],
      hint: el.querySelector('.hs-lb__hint'),
      items: [], idx: 0, open: false, closing: false, pushed: false,
      z: { s: 1, x: 0, y: 0 }
    };
    lb = st;

    el.querySelector('.hs-lb__close').addEventListener('click', () => close());
    addEventListener('popstate', () => { if (st.open) { st.pushed = false; close(); } });
    addEventListener('keydown', e => {
      if (!st.open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(st.idx + 1);
      else if (e.key === 'ArrowLeft') go(st.idx - 1);
    });
    let q = false;
    st.track.addEventListener('scroll', () => {
      if (q) return;
      q = true;
      requestAnimationFrame(() => {
        q = false;
        const f = st.track.scrollLeft / (st.track.clientWidth || 1);
        if (st.rail) st.rail.set(f);
        const i = Math.round(f);
        if (i !== st.idx) { resetZoom(false); setIdx(i); }
      });
    }, { passive: true });
    gestures(st);
    return st;
  }

  const curImg = () => lb.track.children[lb.idx] && lb.track.children[lb.idx].querySelector('img');
  function setIdx(i) {
    lb.idx = Math.max(0, Math.min(lb.items.length - 1, i));
    lb.count.textContent = (lb.idx + 1) + ' / ' + lb.items.length;
    /* komşu fotoğraflar önceden yüklenir */
    [lb.idx - 1, lb.idx, lb.idx + 1].forEach(j => {
      const img = lb.track.children[j] && lb.track.children[j].querySelector('img');
      if (img && !img.src) img.src = img.dataset.src;
    });
  }
  function go(i, smooth = true) {
    lb.track.scrollTo({ left: Math.max(0, Math.min(lb.items.length - 1, i)) * lb.track.clientWidth, behavior: smooth && !reduced ? 'smooth' : 'instant' });
  }

  function open(ul, li) {
    const v = viewer();
    if (v.open || v.closing) return;
    const all = slidesOf(ul).filter(isImage);
    if (!all.length) return;
    v.ul = ul;
    v.items = all.map(s => {
      const img = s.querySelector('img');
      return { li: s, img, src: bigSrc(img), alt: img.alt || '', w: natW(img), h: natH(img) };
    });
    const start = Math.max(0, v.items.findIndex(it => it.li === li));
    v.track.innerHTML = v.items.map(it =>
      '<li class="hs-lb__slide"><img class="hs-lb__img" alt="' + it.alt.replace(/"/g, '&quot;') + '" data-src="' + it.src + '"' + (it.w && it.h ? ' width="' + it.w + '" height="' + it.h + '"' : '') + ' decoding="async" draggable="false"></li>'
    ).join('');
    v.foot.innerHTML = '';
    v.rail = makeRail(v.items.map(it => it.img), go, 'hs-gal-rail--lb');
    v.foot.appendChild(v.rail.el);
    v.z = { s: 1, x: 0, y: 0 };
    v.el.classList.remove('is-zoomed');
    v.el.hidden = false;
    document.documentElement.classList.add('hs-lb-open');
    v.open = true;
    v.track.scrollLeft = start * v.track.clientWidth;
    v.rail.fit();
    v.rail.set(start);
    const target = v.track.children[start].querySelector('img');
    const from = v.items[start].img;
    /* yüksek çözünürlüklü dosya gelene kadar galerideki dosya gösterilir; uçuş anında başlar */
    target.src = from.currentSrc || from.src;
    const hi = new Image();
    hi.onload = () => { if (target.isConnected) target.src = v.items[start].src; };
    hi.src = v.items[start].src;
    setIdx(start);
    try { history.pushState({ hsLb: 1 }, ''); v.pushed = true; } catch (e) { v.pushed = false; }
    v.el.tabIndex = -1;
    v.el.focus({ preventScroll: true });

    const fly = () => {
      if (reduced) return;
      const a = shown(from), b = shown(target);
      if (!a.w || !b.w) return;
      /* kaynak fotoğraf ekranda değilse (sayfanın aşağısından açıldı) uçmak yerine yerinde büyüyerek açılır */
      if (a.y + a.h < 0 || a.y > innerHeight) {
        target.animate([{ transform: 'scale(.94)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 320, easing: EASE });
        v.bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
        v.chrome.forEach(c => c.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, delay: 120, fill: 'backwards' }));
        return;
      }
      const dx = (a.x + a.w / 2) - (b.x + b.w / 2), dy = (a.y + a.h / 2) - (b.y + b.h / 2), k = a.w / b.w;
      target.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + k + ')' }, { transform: 'none' }], { duration: 340, easing: EASE });
      v.bg.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
      v.chrome.forEach(c => c.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, delay: 120, fill: 'backwards' }));
    };
    fly();

    let seen = false;
    try { seen = sessionStorage.getItem('hs_lb_hint') === '1'; sessionStorage.setItem('hs_lb_hint', '1'); } catch (e) {}
    if (!seen) {
      setTimeout(() => v.hint.classList.add('is-on'), 500);
      setTimeout(() => v.hint.classList.remove('is-on'), 3200);
    }
  }

  function close() {
    const v = lb;
    if (!v || !v.open || v.closing) return;
    v.closing = true;
    if (v.pushed) { v.pushed = false; try { history.back(); } catch (e) {} }
    v.hint.classList.remove('is-on');
    const it = v.items[v.idx];
    /* galeri aynı fotoğrafa getirilir, görüntüleyici oraya küçülerek kapanır */
    if (it && v.ul && it.li.isConnected) {
      const s = slidesOf(v.ul);
      v.ul.scrollTo({ left: it.li.offsetLeft - s[0].offsetLeft, behavior: 'instant' });
    }
    const img = curImg();
    const finish = () => {
      v.el.hidden = true;
      v.track.innerHTML = '';
      v.bg.style.opacity = '';
      v.chrome.forEach(c => { c.style.opacity = ''; });
      document.documentElement.classList.remove('hs-lb-open');
      v.open = false;
      v.closing = false;
      v.z = { s: 1, x: 0, y: 0 };
      v.el.classList.remove('is-zoomed');
    };
    if (reduced || !img || !it || !it.img.isConnected) { finish(); return; }
    const a = shown(img), b = shown(it.img);
    const visible = b.w > 0 && b.y + b.h > 0 && b.y < innerHeight;
    const cur = img.style.transform || 'none';
    const bgFrom = getComputedStyle(v.bg).opacity;
    const anims = [
      v.bg.animate([{ opacity: bgFrom }, { opacity: 0 }], { duration: 260, easing: 'ease-in', fill: 'forwards' }),
      ...v.chrome.map(c => c.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, fill: 'forwards' }))
    ];
    if (visible && a.w) {
      const dx = (b.x + b.w / 2) - (a.x + a.w / 2), dy = (b.y + b.h / 2) - (a.y + a.h / 2), k = b.w / a.w;
      img.style.transform = 'none';
      /* a, mevcut (yakınlaştırılmış ya da çekilmiş) konumdur; oradan galerideki yerine */
      const base = shown(img);
      const ox = (a.x + a.w / 2) - (base.x + base.w / 2), oy = (a.y + a.h / 2) - (base.y + base.h / 2), ok = a.w / base.w;
      anims.push(img.animate([
        { transform: 'translate(' + ox + 'px,' + oy + 'px) scale(' + ok + ')' },
        { transform: 'translate(' + (ox + dx) + 'px,' + (oy + dy) + 'px) scale(' + ok * k + ')' }
      ], { duration: 300, easing: EASE, fill: 'forwards' }));
    } else {
      anims.push(img.animate([{ transform: cur, opacity: 1 }, { transform: cur, opacity: 0 }], { duration: 200, fill: 'forwards' }));
    }
    Promise.all(anims.map(an => an.finished.catch(() => {}))).then(() => { anims.forEach(an => an.cancel()); finish(); });
  }

  /* ---------- yakınlaştırma ve aşağı çekerek kapatma ---------- */
  function apply(img, z, animate) {
    const t = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
    if (animate && !reduced) img.animate([{ transform: img.style.transform || 'none' }, { transform: t }], { duration: 220, easing: EASE });
    img.style.transform = z.s === 1 && !z.x && !z.y ? '' : t;
    lb.el.classList.toggle('is-zoomed', z.s > 1.01);
  }
  function resetZoom(animate) {
    const img = curImg();
    lb.z = { s: 1, x: 0, y: 0 };
    if (img) apply(img, lb.z, animate);
    lb.bg.style.opacity = '';
  }
  /* yakınlaştırılmış resim kenarlarından taşmasın */
  function clamp(img, z) {
    const bw = img.offsetWidth, bh = img.offsetHeight;
    const nw = natW(img) || bw, nh = natH(img) || bh;
    const k = Math.min(bw / nw, bh / nh) || 1;
    const cw = nw * k * z.s, ch = nh * k * z.s;
    const mx = Math.max(0, (cw - bw) / 2), my = Math.max(0, (ch - bh) / 2);
    z.x = Math.max(-mx, Math.min(mx, z.x));
    z.y = Math.max(-my, Math.min(my, z.y));
    return z;
  }

  function gestures(v) {
    const t = v.track;
    let mode = '', p0 = null, z0 = null, d0 = 0, m0 = null, lastTap = 0, lastPt = null, t0 = 0, moved = false;
    const pt = e => ({ x: e.clientX, y: e.clientY });
    const mid = (a, b) => ({ x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 });
    const dist = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
    const center = () => { const r = t.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; };

    t.addEventListener('touchstart', e => {
      const img = curImg();
      if (!img) return;
      moved = false;
      if (e.touches.length === 2) {
        e.preventDefault();
        mode = 'pinch';
        d0 = dist(e.touches[0], e.touches[1]);
        m0 = mid(e.touches[0], e.touches[1]);
        z0 = { ...v.z };
      } else if (e.touches.length === 1) {
        p0 = pt(e.touches[0]);
        t0 = performance.now();
        z0 = { ...v.z };
        mode = v.z.s > 1.01 ? 'pan' : 'pending';
        if (mode === 'pan') e.preventDefault();
      }
    }, { passive: false });

    t.addEventListener('touchmove', e => {
      const img = curImg();
      if (!img || !mode) return;
      if (mode === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        const c = center(), m = mid(e.touches[0], e.touches[1]);
        const s = Math.max(1, Math.min(4, z0.s * dist(e.touches[0], e.touches[1]) / (d0 || 1)));
        /* parmakların ortasındaki nokta yerinde kalır */
        const lx = (m0.x - c.x - z0.x) / z0.s, ly = (m0.y - c.y - z0.y) / z0.s;
        v.z = clamp(img, { s, x: m.x - c.x - s * lx, y: m.y - c.y - s * ly });
        apply(img, v.z);
        moved = true;
        return;
      }
      if (e.touches.length !== 1) return;
      const p = pt(e.touches[0]), dx = p.x - p0.x, dy = p.y - p0.y;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) moved = true;
      if (mode === 'pan') {
        e.preventDefault();
        v.z = clamp(img, { s: z0.s, x: z0.x + dx, y: z0.y + dy });
        apply(img, v.z);
      } else if (mode === 'pending') {
        if (dy > 10 && Math.abs(dy) > Math.abs(dx) * 1.2) mode = 'dismiss';
        else if (Math.abs(dx) > 10) mode = 'scroll';
      }
      if (mode === 'dismiss') {
        e.preventDefault();
        const y = Math.max(0, dy);
        img.style.transform = 'translate(' + dx * 0.25 + 'px,' + y + 'px) scale(' + (1 - Math.min(y / 1400, 0.18)) + ')';
        v.bg.style.opacity = String(Math.max(0.25, 1 - y / 480));
        v.chrome.forEach(c => { c.style.opacity = String(Math.max(0, 1 - y / 160)); });
      }
    }, { passive: false });

    t.addEventListener('touchend', e => {
      const img = curImg();
      if (!img) { mode = ''; return; }
      if (mode === 'pinch') {
        if (e.touches.length === 1) { mode = 'pan'; p0 = pt(e.touches[0]); z0 = { ...v.z }; return; }
        if (v.z.s < 1.05) resetZoom(true);
        mode = '';
        return;
      }
      if (mode === 'dismiss') {
        const p = pt(e.changedTouches[0]), dy = p.y - p0.y, vy = dy / Math.max(1, performance.now() - t0);
        v.chrome.forEach(c => { c.style.opacity = ''; });
        if (dy > 110 || vy > 0.6) { mode = ''; close(); return; }
        img.animate([{ transform: img.style.transform }, { transform: 'none' }], { duration: 220, easing: EASE });
        img.style.transform = '';
        v.bg.style.opacity = '';
        mode = '';
        return;
      }
      /* çift dokunuş: yakınlaştır / geri al */
      if (!moved && e.touches.length === 0 && e.changedTouches.length === 1) {
        const p = pt(e.changedTouches[0]), now = performance.now();
        if (now - lastTap < 300 && lastPt && Math.hypot(p.x - lastPt.x, p.y - lastPt.y) < 30) {
          lastTap = 0;
          if (v.z.s > 1.01) resetZoom(true);
          else {
            const c = center(), s = 2.5;
            v.z = clamp(img, { s, x: (p.x - c.x) * (1 - s), y: (p.y - c.y) * (1 - s) });
            apply(img, v.z, true);
          }
          e.preventDefault();
        } else { lastTap = now; lastPt = p; }
      }
      mode = '';
    }, { passive: false });
    t.addEventListener('touchcancel', () => { if (mode === 'dismiss') { resetZoom(true); v.chrome.forEach(c => { c.style.opacity = ''; }); } mode = ''; });
  }

  /* fotoğrafa dokunuş: galeri uygulamasının Fancybox penceresi ve Dawn penceresi yerine görüntüleyici.
     Fancybox dokunuşu pointerup'ta yakalayıp tıklamayı engellediği için dokunuş window üzerinde, ondan önce alınır. */
  const SEL = 'media-gallery .product__media-toggle, media-gallery .product__modal-opener, media-gallery .product__media img';
  const target = e => {
    if (!mq.matches) return null;
    const hit = e.target && e.target.closest && e.target.closest(SEL);
    const li = hit && hit.closest('li');
    const ul = li && li.parentElement;
    return ul && ul.matches('ul.product__media-list') && isImage(li) ? { ul, li } : null;
  };
  let down = null, swallow = 0;
  addEventListener('pointerdown', e => {
    down = target(e) ? { x: e.clientX, y: e.clientY, t: performance.now() } : null;
  }, true);
  const tap = e => {
    const hit = target(e);
    if (!hit) return;
    if (e.type === 'pointerup') {
      const ok = down && Math.hypot(e.clientX - down.x, e.clientY - down.y) < 10 && performance.now() - down.t < 600;
      down = null;
      if (!ok) return;
      swallow = performance.now();
      e.preventDefault();
      e.stopImmediatePropagation();
      bindGallery(hit.ul);
      open(hit.ul, hit.li);
      return;
    }
    /* aynı dokunuşun touchend / click olayları başka pencereyi açmasın */
    if (performance.now() - swallow < 800 || e.type === 'click') {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (e.type === 'click' && performance.now() - swallow >= 800) { bindGallery(hit.ul); open(hit.ul, hit.li); }
    }
  };
  ['pointerup', 'touchend', 'click'].forEach(t => addEventListener(t, tap, { capture: true, passive: false }));

  /* sayfanın başka bir yerinden (Öne çıkanlar) belirli bir fotoğrafı tam ekranda açmak için; telefonda değilse false */
  window.hsGalleryOpenMedia = id => {
    if (!mq.matches) return false;
    const li = [...document.querySelectorAll('media-gallery ul.product__media-list > li')].find(l => l.offsetWidth > 0 && l.id.endsWith('-' + id));
    if (!li || !isImage(li)) return false;
    bindGallery(li.parentElement);
    open(li.parentElement, li);
    return true;
  };

  let queued = false;
  const rescan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  addEventListener('load', scan);
  document.addEventListener('hs:pdp-swapped', rescan);
  mq.addEventListener('change', rescan);
  new MutationObserver(rescan).observe(document.documentElement, { childList: true, subtree: true });
})();
